<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/attributes-order -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t('title.editClass') }}</h3>
          </template>

          <template #right-element>
            <router-link :to="{name: 'ClasseList'}" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left"></i>
              {{ $t('button.retour') }}
            </router-link>
          </template>
        </TopTemplate>

        <div v-if="is_created" class="alert alert-success" role="alert">
          La classe <router-link style="color: black; font-weight: 600" :to="{name: 'DetailsClasse', params: {id: classeId}}">{{ className }}</router-link> a été ajoutée avec
          succès !
        </div>
        <div v-if="messageError" class="alert alert-danger" role="alert">
          {{ $t('error.existClass') }}
        </div>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="!loading" class="ajout-container ajout-container-classe">
          <form @submit.prevent="onSubmitUpdateClasse" novalidate>
            <div class="row first-row">
              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-xs-12 select-wrapper">
                <div class="ajout-container__simple">
                  <label class="label">{{ $t('classe.form.niveau') }} <sup>*</sup></label>
                  <v-select
                    v-model="classe.selectedLevel"
                    :options="levels"
                    label="name"
                    :searchable="true"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="v$.classe.selectedLevel.$error ? 'is-invalid' : ''"
                  >
                    <template #no-options="{search, searching, loading}"> {{ $t('info.noResult') }} </template>
                  </v-select>
                  <span v-if="v$.classe.selectedLevel.$error" class="invalid-feedback">
                    {{ v$.classe.selectedLevel.$errors[0].$message }}
                  </span>
                </div>
              </div>

              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-xs-12">
                <div class="ajout-container__simple-input">
                  <label class="label">{{ $t('classe.form.name') }} <sup>*</sup></label>
                  <div class="simple-input">
                    <input v-model="classe.class_name" type="text" class="form-control" :class="v$.classe.class_name.$error ? 'is-invalid' : ''" />
                    <span v-if="v$.classe.class_name.$error" class="invalid-feedback">
                      {{ v$.classe.class_name.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-xs-12 simple-input">
                <label class="label">{{ $t("classe.form.emploi") }}</label>
                <label
                  class="input-image"
                  for="otherDoc"
                  @change="onFileChange"
                >
                  <div class="file-name">
                    <span class="justify--" v-if="namedoc">
                      {{ namedoc }}
                    </span>
                    <span class="justify--- err article" v-else>
                      {{ $t("info.downloadDocs") }}
                    </span>
                  </div>
                  <div class="icon-upload">
                          <img src="../../assets/icons/VectorMsg.svg" />
                        </div><input
                          id="otherDoc"
                          type="file"
                          class="d-none"
                          accept=".pdf"
                          tabindex="-1"
                        /></label
                >
              </div>
            </div>
            <!-- <div class="row first-row">
                <div class="col-md-6">
                  <div class="ajout-container__simple">
                    <label class="label">Niveau <sup>*</sup></label>
                    <v-select
                      v-model="classe.selectedLevel"
                      :options="levels"
                      label="name"
                      :reduce="(option) => option.id"
                      class="form-control"
                      :class="v$.classe.selectedLevel.$error? 'is-invalid': ''"
                    />
                    <span
                      class="invalid-feedback"
                      v-if="v$.classe.selectedLevel.$error"
                    >
                      {{ v$.classe.selectedLevel.$errors[0].$message }}
                    </span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="ajout-container__simple-input">
                    <label class="label">Nom de la classe <sup>*</sup></label>
                    <div class="simple-input">
                      <input
                        type="text"
                        v-model="classe.class_name"
                        class="form-control"
                        :class="v$.classe.class_name.$error? 'is-invalid': ''"
                      />
                      <span
                        class="invalid-feedback"
                        v-if="v$.classe.class_name.$error"
                      >
                        {{ v$.classe.class_name.$errors[0].$message }}
                      </span>
                      <span v-if="(messageError !==null)" style="color:#dc3545;">
                        {{messageError}}
                      </span>
                    </div>
                  </div>
                </div>
              </div> -->

            <div class="wrapper-top">
              <label class="label">{{ $t('classe.form.courses') }}</label>
              <div class="row items-wrapper mx-auto">
                <div
                  v-for="course in courses"
                  :key="course.id"
                  style="cursor: pointer"
                  class="matiere-item col-xl-3 col-lg-5 col-md-6 col-sm-6 col-xs-12"
                  :class="{matierebackground: isActive(course.id)}"
                  @click="checkItem(course.id)"
                >
                  <span>{{ course.name }}</span>
                  <label class="container-checkbox">
                    <input type="checkbox" v-model="selected" :value="course.id" />
                    <span class="checkmark" />
                  </label>
                </div>
              </div>
              <div class="text-end">
                <button type="submit" class="btn button btn-primary btn-soumettre" :disabled="loading">
                  <i class="icon-Check"></i>
                  {{$t('button.envoi')}}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import ClasseService from "../../services/classe.service";
import CoursesService from "../../services/courses.service";
import {el} from "date-fns/locale";
export default {
  name: "AjoutClasse",
  components: {
    "v-select": vSelect,
    TopTemplate,
  },
  data() {
    return {
      fileName: null,
      fileUrl: null,
      v$: useValidate(),
      classeId: null,
      className: null,
      classe: new Form({
        selectedLevel: null,
        teachers_id: null,
        class_name: null,
        regime: 0,
      }),
      levels: [],
      courses: [],
      listTeacherIds: [],
      coursesList: [],
      selected: [],
      //selectedShow:[],
      school_id: null,
      id_courses: [],
      id_teachers: [],
      messageError: false,
      loading: false,
      is_created: false,
      namedoc: null,
      teachersIds: []
    };
  },
  validations() {
    return {
      classe: {
        selectedLevel: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        class_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  created() {
    this.classeId = this.$route.params.id;
  },
  mounted() {
    this.school_id = this.$store.state.auth.user.school_id;

    this.getById();
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
      this.namedoc = this.file.name;
      this.classe.timetable = "school/timetable" + this.namedoc;
    },
    checkItem(id) {
      if (this.selected.includes(id)) {
        this.selected = this.selected.filter((el) => el != id);
      } else {
        this.selected.push(id);
      }
    },
    isActive(id) {
      if (this.selected.includes(id)) {
        return true;
      } else {
        return false;
      }
    },
    getById() {
      this.loading = true;
      ClasseService.get(this.classeId)
        .then((response) => {
          let data = response.data.data;
          this.classe.selectedLevel = data.level_type;
          this.classe.class_name = data.name;
          this.selected = data.courses.map((v) => v.id);
          this.coursesList = data.courses;
          this.fileUrl = data.timetable;
          this.namedoc = data.timetable_name;
          this.teachersIds = data.teachers_ids;
          this.coursesList.map((element) => delete element["name"]);
          this.LoadDataClass();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    LoadDataClass() {
      allRequests([ClasseService.getFilter({params: {}}), CoursesService.getAll()])
        .then((responses) => {
          this.levels = responses[0].data.types;
          this.courses = _.orderBy(responses[1].data.data, "name");
          this.courses = this.courses.filter((element) => element.is_checked === true);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUniqueListBy(arr, keys) {
  return [...new Map(arr.map((item) => [keys.map(key => item[key]).join("_"), item])).values()];
},

    async onSubmitUpdateClasse() {
      this.v$.$validate();
      let tab = [];
      let arrayC = [];
      let result = [];
      this.selected.map((element) => {
        let object = {id: element, teacher_id: null};
        element = object;
        tab.push(element);
      });
      arrayC = [...tab, ...this.coursesList];
      result = this.getUniqueListBy(arrayC, ["id", "teacher_id"]);
      arrayC = [];
      this.selected.filter((val) => {
  let matchedItems = result.filter((element) => element.id == val);
  matchedItems.forEach(item => {
    arrayC.push(Object.assign({}, item));
  });
});      
      if (!this.v$.$error) {
        /*const data = {
          class_type_id: this.classe.selectedLevel,
          course_ids: this.selected,
          courses:arrayC,
          name: this.classe.class_name,
          regime: 0,
          school_id: this.school_id
        };*/
        let formData = new FormData();
        formData.append("_method", "POST");
        formData.append("class_type_id", Number.isInteger(this.classe.selectedLevel) ? this.classe.selectedLevel : this.classe.selectedLevel.id);
        formData.append("name", this.classe.class_name);
        formData.append("courses", JSON.stringify(arrayC));
        formData.append("course_ids", this.selected);
        formData.append("regime", 0);
        formData.append("school_id", this.school_id);
        if (this.file) {
          formData.append("timetable", this.file);
        } else {
          formData.append("timetable", this.fileUrl);
        }
        await ClasseService.update(this.classeId, formData)
          .then(() => {
            this.messageError = null;
            this.is_created = true;
            this.loading = false;
            this.scrollToTop();
            this.$router.push({name: "DetailsClasse", params: {id: this.classeId}});
          })
          .catch((error) => {
            this.messageError = error.response.data.errors.name ? true : false;
            this.is_created = false;
            this.loading = false;
            this.scrollToTop();
          });
      } else {
        this.loading = false;
        this.is_created = false;
        this.scrollToTop();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
